// jsPDF/autoTable interop shim.
//
// Under a bundler `import jsPDF from "jspdf"` resolves to the constructor, but
// under Node's ESM loader the same import yields the module namespace. Resolve
// both shapes once here so the form modules can stay identical in both places.

import * as jspdfNs from "jspdf";
import * as autoTableNs from "jspdf-autotable";

export const jsPDF = jspdfNs.jsPDF || jspdfNs.default?.jsPDF || jspdfNs.default;

export const autoTable =
  typeof autoTableNs.default === "function"
    ? autoTableNs.default
    : typeof autoTableNs.autoTable === "function"
      ? autoTableNs.autoTable
      : autoTableNs.default?.default;
